module.exports = __webpack_public_path__ + "static/media/notification-payments.3b4c4a6e.svg";